import React from 'react';
import { Accordion as BSAccordion } from 'react-bootstrap';
import AccordionHeader from './Header';
import AccordionBody from './Body';
import AccordionItem from './Item';

/**
 * Accordion do design system (wrapper do react-bootstrap, sempre `flush`).
 *
 * Uso padrão: `defaultActiveKey` como string — um item aberto por vez, abrir um fecha o
 * outro. Para manter mais de um item aberto ao mesmo tempo (ex.: painel do Informe DESSEM,
 * com "Data Analisada" e "Cenário" abertos juntos), passe `defaultActiveKey` como array
 * de `eventKey`s e `alwaysOpen`: cada item abre e fecha sozinho, sem recolher os outros
 * (comportamento `alwaysOpen` do react-bootstrap, que exige a chave ativa em array).
 */
export default function Accordion({
  children,
  defaultActiveKey = '0',
  className = '',
  onSelect = undefined,
  id = undefined,
  alwaysOpen = false,
}: {
  children: React.ReactNode;
  defaultActiveKey?: string | string[];
  className?: string;
  onSelect?: () => void | undefined;
  id?: string | undefined;
  alwaysOpen?: boolean;
}) {
  return (
    <BSAccordion
      defaultActiveKey={defaultActiveKey}
      className={`ds-accordion ${className}`}
      onSelect={onSelect}
      id={id}
      flush
      alwaysOpen={alwaysOpen}
    >
      {children}
    </BSAccordion>
  );
}

Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
Accordion.Item = AccordionItem;
